import { DateTime } from 'luxon';

const FIXED_HOLIDAYS: Array<string> = [
    '01-01', // Day of the Establishment of the Slovak Republic
    '01-06', // Epiphany
    '05-01', // Labour Day
    '05-08', // Victory over Fascism Day
    '07-05', // Saints Cyril and Methodius Day
    '08-29', // Slovak National Uprising Anniversary
    '09-01', // Constitution Day
    '09-15', // Our Lady of Sorrows
    '11-01', // All Saints' Day
    '11-17', // Struggle for Freedom and Democracy Day
    '12-24', // Christmas Eve
    '12-25', // Christmas Day
    '12-26', // St. Stephen's Day
];

function computeEasterSunday(year: number): DateTime {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;

    return DateTime.fromObject({ year, month, day });
}

const cache = new Map<number, Set<string>>();

function getHolidaysForYear(year: number): Set<string> {
    const cached = cache.get(year);
    if (cached) return cached;

    const holidays = new Set<string>();

    for (const md of FIXED_HOLIDAYS) {
        holidays.add(`${year}-${md}`);
    }

    const easter = computeEasterSunday(year);
    holidays.add(easter.minus({ days: 2 }).toISODate()!); // Good Friday
    holidays.add(easter.plus({ days: 1 }).toISODate()!); // Easter Monday

    cache.set(year, holidays);

    return holidays;
}

export function isSlovakHoliday(date: DateTime): boolean {
    const holidays = getHolidaysForYear(date.year);

    return holidays.has(date.toISODate()!);
}

export function countBusinessDays(dateFrom: DateTime, dateTo: DateTime): number {
    const start = dateFrom.startOf('day');
    const end = dateTo.startOf('day');
    const diffDays = Math.round(end.diff(start, 'days').days);

    let count = 0;
    for (let i = 0; i <= diffDays; i++) {
        const current = start.plus({ days: i });
        if (current.weekday <= 5 && !isSlovakHoliday(current)) {
            count++;
        }
    }

    return count;
}
